import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import GiorniListWidget from "../../widgets/GiorniListWidget";
import Insegnati from "../insegnanti/Insegnanti";
import Corsi from "../aule/Aule";
import Aule from "../aule/Aule";
import Materie from "../materie/Materie";
import Categorie from "../categorie/Categorie";

export default class Scuola extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.section = this.props.section;
    if (this.section == undefined) {
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      giorniChiusura: [],
    };

    this.grid = 2;

    this.pageTitle = "Scuola";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();
  }

  async componentDidMount() {}

  render() {
    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 &&
      this.userslist.map((v, k) => {
        rows.push(createData(v.username, v.name, v.surname));
      });

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle title={this.pageTitle} />
          Giorni di chiusura <br />
          <GiorniListWidget
            id={Math.random()}
            name={"Giorni di chiusura"}
            value={this.state.giorniChiusura}
            onChange={(giorni) => {}}
          />
          <Insegnati />
          <Aule />
          <Materie />
          <Categorie />
        </LoadingOverlay>
      </>
    );
  }
}
